import { Font } from '../types'

const font: Font = {
  primary: 'HeroNew, sans-serif',
  secondary: 'HeroNew, sans-serif',
  other: 'HeroNew, sans-serif',
}

export default font
